<div class="iss-exclusive-buttons">
  <label
    class="control button iss-exclusive-buttons__button"
    [issDisabled]="readonly || disabled"
    [class.is-primary.is-selected]="identityFn(item) === value"
    [class.is-focused]="focused"
    *ngFor="let item of items"
  >
    <input
      type="radio"
      [name]="name"
      class="cdk-visually-hidden"
      [value]="identityFn(item)"
      [(ngModel)]="value"
      (ngModelChange)="onChange(value)"
      [disabled]="disabled || !!readonly"
    />
    <ng-container
      [ngTemplateOutlet]="templateRef || naive"
      [ngTemplateOutletContext]="{ $implicit: item }"
    />
  </label>
</div>

<ng-template #naive let-item>{{ textFn(item) }}</ng-template>
